export interface ServiceOffering {
  id: string;
  organizationId?: string; // Optional - services are global until assigned to an org
  name: string;
  description?: string;
  defaultRate: number;
  unit: ServiceUnit;
  category?: string;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
}

export enum ServiceUnit {
  HOUR = 'hour',
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  PROJECT = 'project'
}
